module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-8-873c41ec68c0fdb3d57e8344825c6453.webp";